import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { BsTelephone, BsGeoAlt, BsEnvelope } from "react-icons/bs";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ContactFooter.css";
import Logo from "../../assets/Logo.png";

const ContactFooter = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  

  return (
    <>
      <section className="contact-section py-5 overflow-hidden" id="contact">
        <Container className="mt-md-5 pt-md-5">
          <Row className="g-5">
            {/* Left Column: Contact Information */}
            <Col lg={5}>
              <h1 className="display-3 fw-bold mb-3 contact-title">
                Enquire About Precision Manufacturing
              </h1>
              <p className="text-muted mb-5">
                Connect with us to explore precision machining, stamping, and
                quality-driven manufacturing solutions for OEMs.
              </p>

              <div className="contact-info">
                <div className="mb-4">
                  <h6 className="fw-bold mb-1">Email:</h6>
                  <a
                    href="mailto:janakiram@mkautocomponents.com"
                    className="text-decoration-none text-muted break-word"
                  >
                    janakiram@mkautocomponents.com
                  </a>
                </div>

                <div className="mb-4">
                  <h6 className="fw-bold mb-1">Phone:</h6>
                  <p className="text-muted">+91 9094037085</p>
                </div>

                <div className="mb-4">
                  <h6 className="fw-bold mb-1">Address:</h6>
                  <p className="text-muted">
                    SP-25, 26 & 27, Ambattur Industrial Estate
                    <br />
                    Chennai - 600058.
                    <br />
                    Tamil Nadu. INDIA
                  </p>
                </div>
              </div>
            </Col>

            {/* Right Column: Form & Map */}
            <Col lg={7}>
              <form className="row g-3 mb-4">
                <Col md={6}>
                  <label className="form-label fw-bold small">Name</label>
                  <input
                    type="text"
                    className="form-control custom-input"
                    placeholder="Enter your Name"
                  />
                </Col>
                <Col md={6}>
                  <label className="form-label fw-bold small">Email</label>
                  <input
                    type="email"
                    className="form-control custom-input"
                    placeholder="Enter your Email"
                  />
                </Col>
                <Col md={6}>
                  <label className="form-label fw-bold small">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    className="form-control custom-input"
                    placeholder="Enter your Phone number"
                  />
                </Col>
                <Col md={6}>
                  <label className="form-label fw-bold small">
                    Company Name
                  </label>
                  <input
                    type="text"
                    className="form-control custom-input"
                    placeholder="Enter your Company Name"
                  />
                </Col>
                <Col xs={12}>
                  <label className="form-label fw-bold small">Message</label>
                  <textarea
                    className="form-control custom-input"
                    rows="4"
                    placeholder="Enter your Message"
                  ></textarea>
                </Col>
              </form>

              <div className="map-container shadow-sm border rounded-4 overflow-hidden">
                <iframe
                  title="Location Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.123456789!2d80.1543!3d13.1147!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5263a4369e9c93%3A0x5a1a1a1a1a1a1a1a!2sAmbattur%20Industrial%20Estate!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <footer className="footer-section overflow-hidden">
        <Container>
          {/* TOP ROW: LOGO & NEWSLETTER */}
          <Row className="align-items-center mb-5 gy-4">
            <Col lg={6} md={12} className="text-center text-lg-start">
              <img
                src={Logo}
                alt="MK Components"
                className="footer-logo mx-auto mx-lg-0"
                width="90"
              />
            </Col>

            <Col
              lg={6}
              md={12}
              className="d-flex justify-content-lg-end justify-content-center"
            >
              <div className="newsletter-wrapper">
                <input
                  type="email"
                  placeholder="Email Address"
                  className="newsletter-input"
                />
                <Button className="newsletter-btn">Get in Touch</Button>
              </div>
            </Col>
          </Row>

          {/* MAIN CONTENT ROW */}
          <Row className="mb-5 gy-4">
            <Col lg={5} md={12} className="text-start text-lg-start">
              <p className="footer-desc mx-auto mx-lg-0">
                MK Auto Components is a precision manufacturing company
                specializing in automotive and industrial components, serving
                OEMs and Tier-1 suppliers.
              </p>
            </Col>

            <Col lg={3} md={6} xs={6} className="text-start text-md-start">
              <h5 className="footer-col-title">Company</h5>
              <ul className="footer-links">
                <li>
                  <a className="footer-li" href="#about">
                    About Us
                  </a>
                </li>
                <li>
                  <a className="footer-li" href="#capabilities">
                    Capabilities
                  </a>
                </li>
                <li>
                  <a className="footer-li" href="#products">
                    Products
                  </a>
                </li>
                <li>
                  <a className="footer-li" href="#contact">
                    Contact
                  </a>
                </li>
              </ul>
            </Col>

            <Col lg={4} md={6} xs={6} className="text-start text-md-start">
              <h5 className="footer-col-title">CERTIFICATION</h5>
              <ul className="footer-links certification-list">
                <li>ISO 9001 | IATF 16949</li>
                <li>ISO 14001 | ISO 45001</li>
              </ul>
            </Col>
          </Row>

          {/* BOTTOM CONTACT ROW */}
          <div className="footer-bottom-contact">
            <Row className="gy-4">
              <Col lg={4} md={12}>
                <div className="contact-item justify-content-start justify-content-lg-start">
                  <div className="icon-circle">
                    <BsEnvelope />
                  </div>
                  <span className="break-word">
                    janakiram@mkautocomponents.com
                  </span>
                </div>
              </Col>
              <Col lg={3} md={6}>
                <div className="contact-item justify-content-start justify-content-lg-start">
                  <div className="icon-circle">
                    <BsTelephone />
                  </div>
                  <span>+91 90940 37085</span>
                </div>
              </Col>
              <Col lg={5} md={6}>
                <div className="contact-item justify-content-start justify-content-lg-start">
                  <div className="icon-circle">
                    <BsGeoAlt />
                  </div>
                  <span className="text-center text-lg-start">
                    SP-25, 26, 27, Ambattur Industrial Estate, Chennai-600058
                  </span>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </footer>
    </>
  );
};

export default ContactFooter;
